import * as React from "react";
import { SVGProps } from "react";
const SvgLogoHubspot = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={18}
    height={18}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#logo-hubspot_svg__a)">
      <path
        d="M13.516 6.093V3.98a1.628 1.628 0 0 0 .939-1.467v-.049c0-.899-.729-1.627-1.628-1.627h-.048c-.9 0-1.628.728-1.628 1.627v.049a1.628 1.628 0 0 0 .938 1.467v2.114a4.61 4.61 0 0 0-2.191.965L4.1 2.543c.041-.15.063-.303.065-.457a1.834 1.834 0 1 0-1.836 1.83c.317-.001.629-.086.903-.245l5.709 4.442a4.624 4.624 0 0 0 .07 5.208l-1.736 1.737a1.494 1.494 0 0 0-.434-.07 1.506 1.506 0 1 0 1.508 1.507 1.487 1.487 0 0 0-.07-.434l1.717-1.718a4.632 4.632 0 1 0 3.52-8.25m-.712 6.953a2.376 2.376 0 1 1 0-4.752 2.376 2.376 0 0 1 .003 4.75"
        fill="#FF7A59"
      />
    </g>
    <defs>
      <clipPath id="logo-hubspot_svg__a">
        <path fill="#fff" d="M0 0h18v18H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgLogoHubspot;
